export let TooltipType = /*#__PURE__*/function (TooltipType) {
  TooltipType["UNKNOWN"] = "UNKNOWN";
  TooltipType["USP"] = "USP";
  TooltipType["COMMON"] = "COMMON";
  return TooltipType;
}({});
//# sourceMappingURL=tooltip.js.map